<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-btn icon @click="show = !show" color="teal darken-2" slot="activator">
      <v-icon color="white">{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
    </v-btn>
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="dialog = show = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Details</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-list three-line subheader>
        <v-container class="mt-3">
          <v-layout row wrap>
            <v-flex xs12 sm12 md3>
              <v-img v-bind:src="project.image_url" height="300px" contain></v-img>
            </v-flex>

            <v-flex xs12 sm12 md9 class="px-3">
              <h1>{{ project.title }}</h1>
              <p class="mt-2 white-space-pre">{{ project.description }}</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-list>
      <v-divider></v-divider>
      <v-list three-line subheader>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6 class="px-2">
              <h2>Technologies :</h2>
              <h4>
                <v-icon medium color="primary" class="icon-profile mx-2">fas fa-laptop</v-icon>FrontEnd
              </h4>
              <ul id="example-1" v-if="project.frontend.length!=0">
                <li v-for="item in project.frontend" v-bind:key="item" class="ml-3">{{ item }}</li>
              </ul>
              <ul v-else>Not using frontend for this project</ul>
              <h4>
                <v-icon medium color="primary" class="icon-profile mx-2 mt-2">fas fa-laptop-code</v-icon>BackEnd
              </h4>
              <ul id="example-1" v-if="project.backend.length!=0">
                <li v-for="item in project.backend" v-bind:key="item" class="ml-3">{{ item }}</li>
              </ul>
              <ul v-else>Not using backend for this project</ul>
              <h4 v-if="project.support">
                <v-icon medium color="primary" class="icon-profile mx-2 mt-2">fas fa-headset</v-icon>Support
              </h4>
              <ul id="example-1" v-if="project.support">
                <li v-for="item in project.support" v-bind:key="item" class="ml-3">{{ item }}</li>
              </ul>
            </v-flex>
            <v-flex xs12 sm6 md6 class="px-2">
              <h2>More Info :</h2>
              <a v-bind:href="project.github_url" target="_blank" v-if="project.github_url">
                <v-icon medium color="primary" class="icon-profile mx-2">fab fa-github</v-icon>Github
              </a>
              <v-spacer></v-spacer>
              <p v-if="project.github_url">Click The Icon to see the repository. If the link not work, pardon us because this project was disabled for public</p>
              <a v-bind:href="project.project_url" target="_blank" v-if="project.project_url">
                <v-icon medium color="primary" class="icon-profile mx-2">fas fa-eye</v-icon>Site
              </a>
              <v-spacer></v-spacer>
              <p v-if="project.project_url">Click The Icon to see the site. If the link not work, pardon us because this project was disabled for public</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    project:{
      type: Object,
      required: true
    }
  },
  data(){
    return {
      show: false,
      dialog: false,
    }
  }
}
</script>

